<template>
  <span
    @click="$refs.input.click()"
    :class="['checkbox-wrapper', { 'disabled': disabled }]"
  >
    <input
      type="checkbox"
      ref="input"
      :value="value"
      :checked="model.includes(value)"
      @change="onChange(value)"
    />
    <span class="checkbox"></span>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'ProaCheckBox',
  props: {
    model: {
      type: Array,
      default:() => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: [String, Number]
  },
  methods: {
    onChange: function(value) {
      if (this.model.includes(value)) {
        this.$emit('change', this.model.filter(v => v != value))
      } else {
        this.$emit('change', this.model.concat([value]))
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.checkbox-wrapper {
  cursor: pointer;

  &.disabled {
    cursor: auto;
    pointer-events: none;
    opacity: 0.5;
  }
}

input[type="checkbox"] {
  display: none;
}

.checkbox {
  box-sizing: border-box;
  display: inline-block;
  padding: 5px 17px;
  position: relative;
  width: auto;
}
.checkbox::before {
  content: '';
  display: block;
  height: 16px;
  left: 5px;
  margin-top: -8px;
  position: absolute;
  top: 50%;
  width: 16px;
  border: 2px solid $dark-border-color;
  border-radius: 50%;
  background-color: white;
}
.checkbox::after {
  content: '';
  border-right: 2.5px solid white;
  border-bottom: 2.5px solid white;
  display: block;
  height: 10px;
  width: 6px;
  left: 10px;
  margin-top: -6px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
}

input[type=checkbox]:checked + .checkbox::before {
  border: none;
  background-color: $secondary-color;
}

input[type=checkbox]:checked + .checkbox::after {
  opacity: 1;
}

</style>
